export const LANGUAGE = {
  SUPPORTED_LANGUAGE: [
    {
      name: 'English',
      key: 'us',
      language: 'en'
    },
    {
      name: 'Français',
      key: 'fr',
      language: 'fr'
    },
    {
      name: 'Tiếng Việt',
      key: 'vn',
      language: 'vi'
    },
    {
      name: 'Pусский',
      key: 'ru',
      language: 'ru'
    }
  ],
  DEFAULT: 'en'
};
